import { isPast } from 'date-fns'
import type { Event } from '@/models'

export const useEventStore = defineStore('event.store', () => {
  const seoMetaStore = useSeoMetaStore()

  const eventState = ref<Undefinable<Event>>(undefined)
  const eventListState = ref<Undefinable<Event[]>>(undefined)
  const errors = ref<string[]>([])

  const event = computed(
    () => (!errors.value.length && eventState.value) || undefined,
  )
  const eventList = computed(
    () =>
      (!errors.value.length &&
        !!eventListState.value?.length &&
        eventListState.value) ||
      undefined,
  )
  const seoMeta = computed(() => {
    return seoMetaStore.seoMeta
  })
  const isEventPast = computed(
    () =>
      !!eventState.value &&
      !!eventState.value.dateRangeWithTimezone?.endsAt &&
      isPast(new Date(eventState.value.dateRangeWithTimezone.endsAt)),
  )
  const isFanCodeRequired = computed(
    () => !!eventState.value?.isFanCodeRequired,
  )
  /**
   * Возвращает максимальное количество билетов,
   * которое можно купить на событие в рамках одного заказа
   * @returns {number} значение параметра maxTicketsInOrder,
   * если у события установлено ограничение, либо 0 (=== нет ограничений)
   */
  const maxTicketsInOrder = computed(
    () => eventState.value?.maxTicketsInOrder || 0,
  )

  const setEvent = (event: Event) => {
    if (typeof event !== 'object' || !event) {
      return errors.value.push(
        StringifyError({
          namespace: 'event',
          error: 'not an event',
          message: 'not an event',
        }),
      )
    }

    errors.value = []
    eventState.value = event
  }

  const setEventList = (events: Event[]) => {
    if (!Array.isArray(events)) {
      return errors.value.push(
        StringifyError({
          namespace: 'event list',
          error: 'not event list',
          message: 'not event list',
        }),
      )
    }

    errors.value = []
    eventListState.value = events
  }

  return {
    eventState,
    eventListState,
    event,
    eventList,
    seoMeta,
    isEventPast,
    isFanCodeRequired,
    maxTicketsInOrder,
    setEvent,
    setEventList,
  }
})
